/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/styles';
import GenericSkeleton from '../../GraphqlSkeletonComponents/GenericSkeleton';

const useStyles = makeStyles({
    containr: {
        maxWidth: '1440px',
        margin: '0 auto',
    },
    loadingTitle: {
        maxWidth: '600px',
        width: '100%',
        margin: 'auto',
    },
    banner: {
        padding: '10px',
    },
    loadingCards: {
        display: 'flex',
        justifyContent: 'space-between',
        '&>div': {
            width: '98vw',
            minWidth: '180px',
            maxWidth: '340px',
            margin: '10px !important',
        },
        '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
        },
    },
});

export const RenderTitle = () => {
    const classes = useStyles();
    return <div className={classes.loadingTitle}><GenericSkeleton height="50px" width="100%" /></div>;
};
export const RenderBanner = () => {
    const classes = useStyles();
    return <div className={classes.banner}><GenericSkeleton height="400px" width="100%" /></div>;
};
export const RenderCards = () => {
    const classes = useStyles();
    return (
        <div>
            {RenderTitle()}
            <div className={classes.loadingCards}>
                <GenericSkeleton height="300px" width="100%" />
                <GenericSkeleton height="300px" width="100%" />
                <GenericSkeleton height="300px" width="100%" />
                <GenericSkeleton height="300px" width="100%" />
            </div>
        </div>
    );
};

const GenericTemplateLoader = () => {
    const classes = useStyles();

    return (
        <div className={classes.containr}>
            <RenderBanner classes={classes} />
            <RenderCards classes={classes} />
            <RenderCards classes={classes} />
            <RenderCards classes={classes} />
            <div>
                <RenderTitle classes={classes} />
                <RenderBanner classes={classes} />
            </div>
            <div>
                <RenderTitle classes={classes} />
                <RenderBanner classes={classes} />
            </div>
        </div>
    );
};

export default GenericTemplateLoader;
